import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-GG7KQ2N77X';

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // This part ensures that gtag is defined before we use it.
    // The script is loaded in index.html, so it should be available.
    if (typeof window.gtag === 'function') {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

export default Analytics;